import { useCallback, useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  APP_VERSION_POLL_MS,
  APP_VERSION_URL,
  parseAppVersionId,
  runningAppBuildId,
  shouldPromptNewVersion,
} from "@/lib/app-version";
import { newVersionBannerLayout } from "@/lib/new-version-banner-layout";

async function fetchAppVersionId(): Promise<string | null> {
  try {
    const res = await fetch(`${APP_VERSION_URL}?t=${Date.now()}`, {
      cache: "no-store",
      headers: { Accept: "application/json" },
    });
    if (!res.ok) return null;
    return parseAppVersionId(await res.json());
  } catch {
    return null;
  }
}

export function NewVersionBanner() {
  const [visible, setVisible] = useState(false);

  const check = useCallback(async () => {
    if (import.meta.env.DEV) return;
    const runningId = runningAppBuildId();
    const remoteId = await fetchAppVersionId();
    if (shouldPromptNewVersion(runningId, remoteId)) {
      setVisible(true);
    }
  }, []);

  useEffect(() => {
    void check();
    const id = window.setInterval(() => {
      void check();
    }, APP_VERSION_POLL_MS);
    return () => window.clearInterval(id);
  }, [check]);

  if (!visible) return null;

  return (
    <div role="status" className={newVersionBannerLayout.shell}>
      <div className={newVersionBannerLayout.panel}>
        <p className={newVersionBannerLayout.message}>
          تتوفر نسخة جديدة من الموقع. حدّث الصفحة لتحصل عليها.
        </p>
        <Button
          type="button"
          size="sm"
          variant="secondary"
          className="shrink-0 bg-white text-[#0071BC] hover:bg-white/90"
          onClick={() => window.location.reload()}
        >
          <RefreshCw className="size-4" />
          تحديث الآن
        </Button>
      </div>
    </div>
  );
}
